import React from 'react';

export default function ExpandableList({ content, expanded }: { content: string, expanded: boolean }) {
  if (!expanded) {
    return null;
  }
  return <div dangerouslySetInnerHTML={{ __html: content }} />;
}
